<template>
  <div class="convert-contents-summary">
    <table class="table-summary">
      <thead>
        <tr>
          <th style="width: 160px;">サイト名</th>
          <th>状況検索</th>
          <th class="sent" style="width: 260px;">掲載中</th>
          <th class="expired">期限切れ</th>
          <th class="deleted">削除済み</th>
          <th class="due_today">期限本日</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="summary.length === 0">
          <td colspan="6" style="padding: 16px;">サマリーデータがありません。</td>
        </tr>
        <template v-else>
          <tr v-for="(summaryData, summaryDataIdx) in summary" :key="summaryDataIdx">
            <td>{{ summaryData.portal_site }}</td>
            <td>
              <i-poptip content="content" placement="right">
                <i-button type="primary" size="small" ghost>絞り込み</i-button>
                <div slot="content">
                  <SummaryBtn :summary-data="summaryData" :shopId="shopId" :summary="summary" />
                </div>
              </i-poptip>
            </td>
            <td class="sent">
              <div style="display: flex; align-items: center; justify-content: center;">
                <i-checkbox
                  :label="`${shopId}_${summaryData.cd}_sent`"
                  size="small"
                  @on-change="onChangeSummary(selectSummary[`${shopId}_${summaryData.cd}_sent`], summaryData, 'sent')"
                  v-model="selectSummary[`${shopId}_${summaryData.cd}_sent`]"
                  :true-value="1"
                  :false-value="0"
                >
                  {{ summaryData.sent }}
                </i-checkbox>
                <template v-if="summaryData.panorama">
                  <i-radio-group
                    size="small"
                    @on-change="
                      onChangeSummary(selectSummary[`${shopId}_${summaryData.cd}_panorama`], summaryData, 'panorama')
                    "
                    v-model="selectSummary[`${shopId}_${summaryData.cd}_panorama`]"
                  >
                    <i-radio :label="``">P指定なし</i-radio>
                    <i-radio label="enabled">P有</i-radio>
                    <i-radio label="disabled">P無</i-radio>
                  </i-radio-group>
                </template>
              </div>
            </td>
            <td class="expired">
              <i-checkbox
                :label="`${shopId}_${summaryData.cd}_expired`"
                size="small"
                @on-change="
                  onChangeSummary(selectSummary[`${shopId}_${summaryData.cd}_expired`], summaryData, 'expired')
                "
                v-model="selectSummary[`${shopId}_${summaryData.cd}_expired`]"
                :true-value="1"
                :false-value="0"
              >
                {{ summaryData.expired }}
              </i-checkbox>
            </td>
            <td class="deleted">
              <i-checkbox
                :label="`${shopId}_${summaryData.cd}_deleted`"
                size="small"
                @on-change="
                  onChangeSummary(selectSummary[`${shopId}_${summaryData.cd}_deleted`], summaryData, 'deleted')
                "
                v-model="selectSummary[`${shopId}_${summaryData.cd}_deleted`]"
                :true-value="1"
                :false-value="0"
              >
                {{ summaryData.deleted }}
              </i-checkbox>
            </td>
            <td class="due_today">
              <i-checkbox
                :label="`${shopId}_${summaryData.cd}_due_today`"
                size="small"
                @on-change="
                  onChangeSummary(selectSummary[`${shopId}_${summaryData.cd}_due_today`], summaryData, 'due_today')
                "
                v-model="selectSummary[`${shopId}_${summaryData.cd}_due_today`]"
                :true-value="1"
                :false-value="0"
              >
                {{ summaryData.due_today }}
              </i-checkbox>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Checkbox, Button, Poptip, RadioGroup, Radio } from 'view-design'
import SummaryBtn from './SummaryBtn'
import SummarySearchText from '@/mixins/summary_search_text'
export default {
  mixins: [SummarySearchText],
  components: {
    'i-checkbox': Checkbox,
    'i-button': Button,
    'i-poptip': Poptip,
    'i-radio-group': RadioGroup,
    'i-radio': Radio,
    SummaryBtn,
  },
  data() {
    return {}
  },
  computed: {
    selectSummary: {
      get() {
        return this.$store.getters['ConvertSummary/getSelectSummary']
      },
      set(val) {
        this.$store.commit('ConvertSummary/setSelectSummary', val)
      },
    },
    summary: {
      get() {
        return this.$store.getters['ConvertSummary/getSummary']
      },
      set(val) {
        this.$store.commit('ConvertSummary/setSummary', val)
      },
    },
    shopId() {
      return this.$store.getters['ConvertSummary/getShopId']
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
  },
  methods: {
    // チェックボックス変更時の処理
    onChangeSummary(val, summaryData, type) {
      let data = {}
      data.shop_id = this.shopId
      data.type = type
      data.cd = summaryData.cd

      // パノラマのみ別対応
      if (type === 'panorama') {
        // 一旦削除する
        data.type = `panorama_enabled`
        this.search.summary = _.reject(this.search.summary, data)
        data.type = `panorama_disabled`
        this.search.summary = _.reject(this.search.summary, data)
        // 追加処理
        if (val !== '') {
          data.type = `panorama_${val}`
          this.search.summary.push(data)
        }
      } else {
        if (val) {
          this.search.summary.push(data)
        } else {
          this.search.summary = _.reject(this.search.summary, data)
        }
      }

      // サマリー検索テキストを生成する
      this.summarySearchText(this.shopId)
    },
  },
}
</script>

<style lang="scss" scoped>
.convert-contents-summary {
  .table-summary {
    width: 100%;
    min-width: 720px;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 16px;
    color: #333;

    thead {
      background-color: #efefef;
    }

    tbody {
      background-color: #fff;
    }

    th,
    td {
      vertical-align: middle;
      font-size: 12px;
      padding: 4px;
      border: 1px solid #666;
      text-align: center;

      &.sent {
        background-color: #cbe67d;
      }
      &.expired {
        background-color: #adc0c7;
      }
      &.deleted {
        background-color: #999bd6;
      }
      &.due_today {
        background-color: #ff9b9b;
      }
    }
  }
}
</style>
